<template>
    <div class="search-items">

      <div class="search-filters mt-3 mt-lg-0">

        <div 
          class="alert alert-warning"
          v-if="getWarnings.textSearchValueLength"
        >
          {{$t('tuka.warnings.textSearchValueLength')}} 3
        </div>

        <div :class="hasThemeWords > 0 ? 'text-search' : 'text-search mb-5'">
          <label class="sr-only" for="word-search">{{$t('tuka.search.text_search')}}</label>
          <input 
            v-model="wordSearch" 
            @keydown.enter="activateSearch()"
            type="text" 
            id="word-search" 
            name="Sidebar word search"
            :placeholder="$t('tuka.search.text_input_placeholder')"
            :disabled="isDisabled"
          >
          <button
              class="btn text-search-activate"
              @click="activateSearch()"
              :disabled="isDisabled"
            >
            {{$t('tuka.search.search')}}
          </button>
        </div>

        <div v-if="hasThemeWords > 0" class="themeword-cloud-container">
          <div class="themeword-cloud-header">{{$t('tuka.search.theme_word_search')}}</div>
          <div class="display-accordion-button themeword-cloud-button">
            <button
              class='accordion-button'
              :class="accordion.open ? 'icon-arrow-down' : 'icon-arrow-up'"
              @click="accordion.open = !accordion.open"
              :aria-label="accordion.open ? $t('tuka.navigation.accordion_open') : $t('tuka.navigation.accordion_closed')"
              :aria-expanded="accordion.open ? 'true' : 'false'"
              aria-controls="themeword-cloud"
            >
            </button>
          </div>
          <ul 
            id="themeword-cloud" 
            class="themeword-cloud accordion-content"
            :class="accordion.open ? 'open' : 'closed'"
            v-show="accordion.open"
          >
            <li v-for="(active, name) in themeWords">
              <button
                class="btn"
                :class="active ? 'active' : ''"
                @click="toggleThemeActive(name, active)"
                aria-controls="side-nav-list"
              >{{ name }}</button>
            </li>
          </ul>
        </div>
      </div>

      <search-info />

      <div class="settings-box search-settings">
        <div class="hide-theme-words-with-no-matches" v-if="getFilters.themeWords">
          <input 
            type="checkbox" 
            id="checkbox-hideThemeWordsWithNomatches" 
            v-model="getSettings.hideThemeWordsWithNomatches"
          >
          <label for="checkbox-hideThemeWordsWithNomatches">Tyhjien tulosten piilotus: {{ getSettings.hideThemeWordsWithNomatches }}</label>
        </div>
        <div>
          <input 
            type="checkbox" 
            id="checkbox-showContentInFullHeight" 
            v-model="getSettings.showContentInFullHeight"
          >
          <label for="checkbox-showContentInFullHeight">Sisältö-osan elementtien täysi korkeus: {{ getSettings.showContentInFullHeight }}</label>
        </div>
      </div>

    </div>
</template>
<script>
import axios from "axios";
import SearchInfo from "./SearchInfo.vue";
import { mapActions, mapGetters } from "vuex";
import { i18n } from "../translations/i18n";

import { getContentObjects, modifyPathStringWithParameters } from "../store/helpers";

export default {
  name: "SearchBox",
  props: [],
  components: {
    SearchInfo,
  },
  data() {
    return {
      accordion: {
        open: true
      }
    };
  },
  computed: {
    ...mapGetters(["themeWords", "getSettings", "getFilters", "sidebarContent", "getTextSearchValue", "getTextSearchStaticValue", "getWarnings", "searchResults", "currentItemLocationData","hasThemeWords"]),
    isDisabled() {
      // if (this.searchResults.errorMessage.length || this.searchResults.data.length) return true;
      return false;
    },
    wordSearch: {
      get: function() {
        return this.getTextSearchValue;
      },
      set: function(newValue) {
          this.setTextSearchValue(newValue)

        // Reset warning of search text length
        if (newValue.length >= 3) {
          let tempWarnings = this.getWarnings;
          tempWarnings.textSearchValueLength = false;
          this.setWarnings(tempWarnings);
        }
      }
    }
  },
  methods: {
    ...mapActions(["setSearchResults", "setSettings", "setTextSearchValue", "setTextSearchStaticValue", "setWarnings", "setScrollingReserved", "setThemeWords"]),
    toggleThemeActive(name, active) {
      // Set all themeWords to false
      let currentThemeWords = this.themeWords;
      for (let i in currentThemeWords) {
        currentThemeWords[i] = false;
      }
      // Toggle clicked theme word to opposite true/false
      currentThemeWords[name] = !active;

      let newPathString = this.$route.path;
      if (currentThemeWords[name]) {
        newPathString = "/"; // If themewords filter has been clicked active, load all content
      }

      // Include/modify URL parameters after themeWords state has changed
      newPathString = modifyPathStringWithParameters(currentThemeWords, newPathString);

      // Add current hash to end of URL if themewords-filter has been changed
      // if (this.$router.currentRoute.hash) {
      //   newPathString += this.$router.currentRoute.hash;
      // }

      // Push new path with parameters to router, e.g. /katsaus/2/1?themeword=ilmastonmuutos
      this.$router.push(newPathString).catch(err => { console.log("Reroute to same location, avoiding")});

      // Focus sidebar list
      document.querySelector(".tukave-side-nav").querySelector(".fp").focus({
        preventScroll: true
      })
    },
    activateSearch() {

      // Display warning if search word is under X characters long
      if (this.getTextSearchValue.length < 3) {

        let tempWarnings = this.getWarnings;
        tempWarnings.textSearchValueLength = true;
        this.setWarnings(tempWarnings);

        return;
      }

      // Set text in input box into state
      this.setTextSearchStaticValue(this.wordSearch);

      // Generate componentId array, e.g. ["0","1","3"] --> ["1","3"] 
      let tempLocation = [];
      for (let i = 1; i < this.currentItemLocationData.length; i++) {
        tempLocation.push(this.currentItemLocationData[i]);
      }

      // Prevent root item ["0"] to be inserted to url
      if (tempLocation && tempLocation[0] == "0") {
        tempLocation = [];
      }

      let pushParams = {
        componentPage: this.$router.currentRoute.params.componentPage,
        componentId: tempLocation,
      }

      this.$router.push({
        name: 'componentpage',
        params: pushParams,
        query: { search: this.getTextSearchStaticValue },
        hash: ""
      }).catch(err => { console.log("Reroute to same location, avoiding")})

      // Scroll into top of main content
      this.$nextTick(() => {
        this.setScrollingReserved(true);

        // If menu toggle is visible (mobile mode) close the menu
        if (jQuery('.settings-box.visual-settings:visible').length) {
          let tempSettings = {...this.getSettings};
          tempSettings.showContentWindowInFullWidth = true; // closes mobile menu 
          this.setSettings(tempSettings);
        }

        // Focus container with search results
        document.getElementById('tuka-content-container').focus({
          preventScroll: true
        });

        setTimeout(() => {
          let scrollTarget = jQuery('.tukave-main-content');
          scrollTarget[0].scrollIntoView({behavior: "smooth"});
        }, 100);

        setTimeout(() => {
          this.setScrollingReserved(false);
        }, 2000)
      });

    }
  },
  watch: {},
  created() {},
};
</script>

<style lang="scss" scoped>

</style>